import { Dispatch, useMemo, useReducer } from 'react';
import {
  FEELIX_THEMES, PAYMENT_METHOD, REGIONS, SUBSCRIPTION_TYPE
} from '../../constants';
import { SessionPropertiesType, SessionActionsType, AccountDetail, QuoteDetails } from './sessionType';

const initialState: SessionPropertiesType = {
  accountDetail: undefined,
  pc: '',
  region: REGIONS.AUSTRALIA,
  promoCode: undefined,
  promotionEndDate: undefined,
  promotionTermsLink: undefined,
  productId: '',
  productName: '',
  productFreePeriod: -1,
  phoneNumber: {
    salesPhoneNumber: '',
    customerServicePhoneNumber: '',
    supportPhoneNumber: ''
  },
  checkoutId: (Date.now() + Math.random()).toString().replaceAll('.', '-'),
  isInitialised: false,
  subscriptionType: SUBSCRIPTION_TYPE.TRIAL,
  hasPurchaseSubmitted: false,
  contactArchieRowId: '',
  productInstanceId: '',
  serialNumber: '',
  orderNumber: '',
  isNewUser: false,
  paymentMethod: PAYMENT_METHOD.CREDIT,
  isAnnualPrice: false,
  isAnnualRoute: false,
  theme: FEELIX_THEMES.MODERN,
  emailChecked: false,
  email: ''
};

const sessionReducer =
  (state: SessionPropertiesType, action: Partial<SessionPropertiesType>):
  SessionPropertiesType => ({ ...state, ...action });

const getSessionActions = (setState: Dispatch<Partial<SessionPropertiesType>>): SessionActionsType => ({
  setAccountDetail: (accountDetail: AccountDetail) => setState({ accountDetail }),
  setProductName: (productName: string) => setState({ productName }),
  setPromoCode: (promoCode: string | undefined) => setState({ promoCode }),
  setPromotionEndDate: (promotionEndDate: string | undefined) => setState({ promotionEndDate }),
  setPromotionTermsLink: (promotionTermsLink: string | undefined) => setState({ promotionTermsLink }),
  setProductFreePeriod: (productFreePeriod: number) => setState({ productFreePeriod }),
  setHasPurchaseSubmitted: (hasPurchaseSubmitted: boolean) => setState({ hasPurchaseSubmitted }),
  setProductInstanceId: (productInstanceId: string) => setState({ productInstanceId }),
  setContactArchieRowId: (contactArchieRowId: string) => setState({ contactArchieRowId }),
  setSerialNumber: (serialNumber: string) => setState({ serialNumber }),
  setIsNewUser: (isNewUser: boolean) => setState({ isNewUser }),
  setOrderNumber: (orderNumber: string) => setState({ orderNumber }),
  setPaymentMethod: (paymentMethod: PAYMENT_METHOD) => setState({ paymentMethod }),
  setIsAnnualPrice: (isAnnualPrice: boolean) => setState({ isAnnualPrice }),
  setEmailChecked: (emailChecked: boolean) => setState({ emailChecked }),
  setQuoteId: (quoteId: string | undefined) => setState({ quoteId }),
  setEmail: (email: string) => setState({ email }),
  setIsAnnualRoute(isAnnualRoute: boolean) {
    setState({ isAnnualRoute });
  },
  setQuoteDetails(quoteDetails: QuoteDetails | undefined) {
    setState({ quoteDetails });
  }
});
export const useSessionReducer = ():
[
  SessionPropertiesType,
  Dispatch<Partial<SessionPropertiesType>>,
  SessionActionsType
] => {
  const [state, setState] = useReducer(sessionReducer, initialState);
  const sessionActions = useMemo(() => getSessionActions(setState), [setState]);
  return [state, setState, sessionActions];
};
